import { toast, Zoom } from 'react-toastify'

interface IToastProps {
  title: string
  icon?: React.ReactNode
}

export const renderToast = ({ title, icon }: IToastProps) => {
  toast.success(<p className="whitespace-nowrap font-bold text-white">{title}</p>, {
    toastId: 'kdtApplicationSaved',
    className: 'top-6 px-4 lg:px-5 lg:top-12 rounded-full mx-auto min-h-12 h-12',
    bodyClassName: 'p-0 flex items-center justify-center text-sm lg:text-base font-semibold',
    closeButton: false,
    icon: () => icon ?? <img src="/svg/icon_solid_check.svg" width={18} height={18} alt="check icon" />,
    style: {
      backgroundColor: 'rgba(0, 0, 0, 0.80)', 
      width: 'max-content',
    },
    transition: Zoom,
  })
}
